import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const HeatMapChartSkeleton = () => {
  return (
   <>
          {/* Simulated Heatmap Grid */}
          <div id="chart" className='mt-3'>
            {/* Adjust grid: for example, 7 columns (days) and 5 rows (weeks) */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: '15px',
              }}
            >
              {Array.from({ length: 35 }).map((_, index) => (
                <Skeleton key={index} height={35} />
              ))}
            </div>
          </div>
          </>
  );
};

export default HeatMapChartSkeleton;
